import styles from './index.module.less';
import { Button } from 'antd';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { useAddAccountModal } from '@/context/AddAccountModalProvider';
import { EventNameSource } from '@/shared/event-types';

const Index = () => {
  const { t } = useTranslation();
  const { openAddAccountModal } = useAddAccountModal();

  return (
    <div className={styles.container}>
      <div>
        <h2>{t('Start Removing Leaks with Erasa')}</h2>
        <h3>
          {t(
            "leak will never stop ！Don't let leaks damage your hard work. With Erasa, you can effortlessly remove leaked content and regain control.",
          )}
        </h3>
        <div>
          <Button onClick={() => openAddAccountModal(EventNameSource.compare)}>{t('Get Started')}</Button>
        </div>
        <Image src={'/images/erasa/competions-bottom/girl.webp'} alt="Erasa" height={328} width={470} loading="lazy" />
      </div>
    </div>
  );
};
export default Index;
